import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { TermsAndPrivacyLinks } from '@hcs/auth';
import { Card, LoadingSpinner } from '@hcs/design-system';
import { APP_CONFIG_CANARYAI, APP_CONFIG_PLATFORM } from '@hcs/hc-products';
import {
  SelfServiceConfirmAccount,
  useUserSelfServiceConfirmed,
} from '@hcs/self-service';

import styles from './CanaryAISelfServiceSetupPage.module.css';
const dataHcName = 'canaryai-self-setup-page';

export const CanaryAISelfServiceSetupPage = () => {
  const navigate = useNavigate();
  const { data: isUserConfirmed, isInitialLoading } =
    useUserSelfServiceConfirmed();
  useEffect(() => {
    if (isUserConfirmed) {
      navigate(APP_CONFIG_PLATFORM.rootPath);
    }
  }, [isUserConfirmed, navigate]);
  return (
    <>
      <Card dataHcName={dataHcName} className={styles.Card}>
        {isInitialLoading ? (
          <LoadingSpinner dataHcName={`${dataHcName}-loading-spinner`} />
        ) : (
          <SelfServiceConfirmAccount
            confirmationText={
              <span>
                A confirmation email was sent to your email address. Please
                confirm your email to join the CanaryAI
                <span
                  style={{
                    color: 'rgb(12, 68, 255)',
                    marginLeft: '2px',
                    fontWeight: 100,
                  }}
                >
                  beta
                </span>{' '}
                waitlist.
              </span>
            }
            onGetStarted={() => navigate(APP_CONFIG_CANARYAI.rootPath)}
          />
        )}
      </Card>
      <TermsAndPrivacyLinks />
    </>
  );
};
